<p class="save-reminder">
  {{ 'COMMERCIAL_SERVICES.LABEL.CONTACT_CHANGES_SAVE_REMINDER' | translate }}
</p>
<div class="assignment-picker">
  <p-select
    inputId="facility-contact-picker"
    [ariaLabel]="'COMMERCIAL_SERVICES.LABEL.SELECT_CONTACT' | translate"
    [placeholder]="'COMMERCIAL_SERVICES.LABEL.SELECT_CONTACT' | translate"
    [emptyMessage]="
      'COMMERCIAL_SERVICES.LABEL.NO_AVAILABLE_CONTACTS' | translate
    "
    [options]="pickerOptions()"
    optionLabel="label"
    optionValue="value"
    [filter]="true"
    [showClear]="true"
    [(ngModel)]="selectedContactId"
    appendTo="body"
  />
  <p-button
    icon="fa fa-plus"
    [label]="'COMMERCIAL_SERVICES.LABEL.ASSIGN_CONTACT' | translate"
    [disabled]="!selectedContactId()"
    (onClick)="assignContact()"
  />
</div>
<p-table
  [value]="draftContacts()"
  dataKey="id"
  size="small"
  (onRowReorder)="onRowReorder()"
>
  <ng-template #header>
    <tr>
      <th></th>
      <th>{{ 'COMMERCIAL_SERVICES.LABEL.CONTACT_POSITION' | translate }}</th>
      <th>{{ 'COMMERCIAL_SERVICES.LABEL.FULL_NAME' | translate }}</th>
      <th>{{ 'COMMERCIAL_SERVICES.LABEL.COMPANY' | translate }}</th>
      <th>{{ 'COMMERCIAL_SERVICES.LABEL.ROLE' | translate }}</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template #body let-contact let-index="rowIndex">
    <tr [pReorderableRow]="index">
      <td class="col-fit">
        <span
          pReorderableRowHandle
          class="drag-handle"
          aria-hidden="true"
          [pTooltip]="'COMMERCIAL_SERVICES.LABEL.DRAG_TO_REORDER' | translate"
          tooltipPosition="top"
        >
          <i class="fa fa-fw fa-bars"></i>
        </span>
      </td>
      <td class="col-fit col-rank">{{ index + 1 }}</td>
      <td class="col-fit col-name">{{ fullName(contact) }}</td>
      <td class="col-grow">{{ contact.company?.name }}</td>
      <td class="col-grow">{{ contact.jobRole?.name }}</td>
      <td class="col-actions">
        <p-button
          icon="fa fa-fw fa-arrow-up"
          size="small"
          [text]="true"
          [rounded]="true"
          [disabled]="index === 0"
          [ariaLabel]="'COMMERCIAL_SERVICES.LABEL.MOVE_UP' | translate"
          (onClick)="move(index, -1)"
        />
        <p-button
          icon="fa fa-fw fa-arrow-down"
          size="small"
          [text]="true"
          [rounded]="true"
          [disabled]="index === draftContacts().length - 1"
          [ariaLabel]="'COMMERCIAL_SERVICES.LABEL.MOVE_DOWN' | translate"
          (onClick)="move(index, 1)"
        />
        <p-button
          icon="fa fa-fw fa-trash"
          size="small"
          [text]="true"
          [rounded]="true"
          [ariaLabel]="'COMMERCIAL_SERVICES.LABEL.REMOVE_CONTACT' | translate"
          [pTooltip]="'COMMERCIAL_SERVICES.LABEL.REMOVE_CONTACT' | translate"
          tooltipPosition="top"
          (onClick)="remove(contact.id)"
        />
      </td>
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="6" class="empty">
        {{ 'COMMERCIAL_SERVICES.LABEL.NO_CONTACT_ASSIGNED' | translate }}
      </td>
    </tr>
  </ng-template>
</p-table>
<div class="dialog-footer">
  <p-button
    [label]="'COMMON.LABEL.BUTTONS.CANCEL' | translate"
    [text]="true"
    (onClick)="cancel()"
  />
  <p-button
    [label]="'COMMERCIAL_SERVICES.LABEL.APPLY_CONTACT_CHANGES' | translate"
    [disabled]="!hasChanges()"
    (onClick)="applyChanges()"
  />
</div>
